<template>
    <div class="choosetickets">
        <div class="active_info flex_c">
            <img :src="eventInfo.coveratturl">
            <div class="info">
                <div class="info_title">{{eventInfo.title}}</div>
                <div class="info_time">{{eventInfo.begintime}}-{{eventInfo.endtime}}</div>
                <div class="info_addr">{{eventInfo.address}}</div>
            </div>
        </div>
        <div class="ticket_list">
            <div v-for="(item, index) in ticketList" :key="index" class="ticket_item flex_c" @click="chooseTicket(index, item)" :style="{'border': currentIdx === index ? '.02rem solid #0ABF53' : ''}">
                <div class="item_l">
                    <div class="name_ticket flex_c">
                        <p class="name">{{item.name}}</p>
                        <p class="ticket" v-if="item.isaudit" :style="{'color': item.status === 20 || item.status === 9 ? '#999' : '#FF4747', 'border': item.status === 20 || item.status === 9 ? '.01rem solid #999' : '.01rem solid #FF4747'}">需要审核</p>
                    </div>
                    <div class="price_tips flex_c">
                        <p class="price" :style="{'color': item.status === 20 || item.status === 9 ? '#999' : '#0ABF53'}"><span v-if="item.tickettypename === '收费'">¥</span>{{item.tickettypename === '免费' ? '免费' : item.uprice}}</p>
                        <p v-if="item.seasonticketcount !== 1" class="tips">{{item.seasonticketcount}}人套票</p>
                    </div>
                    <div v-if="currentIdx === index" class="ticket_memo">{{item.memo}}</div>
                </div>
                <div v-if="item.status === 20 || item.status === 9" class="item_r">
                    <img :src="item.status === 20 ? imgList.sellOut : item.status === 9 ? imgList.stop : ''" alt="">
                </div>
                <img v-if="currentIdx === index" :src="require('@/common/images/activeTools/green_arrow.png')" class="right_arrow">
            </div>
        </div>
        <div class="fixed_btns flex_c">
            <div class="add flex_c">
                <img :src="require('@/common/images/activeTools/decrease.png')" alt="" @click="decreaseNum">
                <span class="num">{{ticketNum}}</span>
                <img :src="require('@/common/images/activeTools/add_icon.png')" alt="" @click="addNum">

            </div>
            <div class="next" @click="nextSteps">下一步</div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getEventTicketInfo} from 'api/activeTools.js'
import { Toast } from 'vant'
// import OfficialBar from '../components/officialBar'
export default {
    name: 'chooseTickets',
    data() {
        return {
            eventid: this.$route.query.eventid ? this.$route.query.eventid : '1000016',
            eventInfo: {},
            ticketList: [],
            imgList: {
                sellOut: require('@/common/images/activeTools/over_sale.png'),
                stop: require('@/common/images/activeTools/stop_sale.png')
            },
            currentIdx: 0,
            ticketNum: 1,
            ticketItem: {}
        }
    },
    mounted() {
      this.getTicketList()
        document.title = '票种选择'
    },
    activated() {
      if (this.refresh) {
        this.eventid = this.$route.query.eventid ? this.$route.query.eventid : ''
        this.getTicketList()
        this.setRefresh(false)
      }
    },
    methods: {
        getTicketList() {
            let data = {
                eventid: this.eventid
            }
            getEventTicketInfo({
                data: data,
                success: data => {
                    this.setLoading(false)
                    if (data.data) {
                        this.eventInfo = data.data.eventinfo
                        this.ticketList = data.data.eventticketinfo
                      console.log(this.ticketList)
                      let list = this.ticketList
                        // this.ticketItem = list[0]
                        for (let i=0; i<list.length; i++) {
                            if(list[i].status === 1) {
                                this.ticketItem = list[i]
                                this.currentIdx = i
                                return
                            }
                        }
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },

        // 选择票种
        chooseTicket(idx, item) {
            console.log(item.status)
            if (item.status === 1){
                this.currentIdx = idx
                this.ticketItem = item
                this.ticketNum = 1
            } else {
                let text = item.status === 20 ? '售罄' : item.status === 9 ? '暂停' : ''
                Toast('该票种已' + text)
            }
        },

        // 票数减少
        decreaseNum() {
            if (this.ticketNum > 1) {
                this.ticketNum --
            }
        },

        // 票数增加
        addNum() {
            let num = parseInt(this.ticketNum)
            this.ticketNum = num ++
            if (this.ticketNum < this.ticketItem.currentmaxbuycount) {
                this.ticketNum ++
            } else {
                Toast('该票限购' + this.ticketItem.currentmaxbuycount + '张')
            }
        },

        // 下一步
        nextSteps() {
            this.setAaEnrollmentList([])
            this.setAaEnrollment(false)
            this.setIsInit(true)
            this.$router.push({name: 'AaConfirmOrder', query: {eventid: this.eventInfo.eventid, ticketcount: this.ticketNum, ticketid: this.ticketItem.ticketid}})
        },

        ...mapActions([
            'setLoading',
            'setAaEnrollment',
            'setIsInit',
            'setAaEnrollmentList',
            'setRefresh'
        ])
    },
    watch: {
        user(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.getTicketList()
            })
        }
    },
    computed: {
        ...mapGetters([
            'user',
            'refresh'
        ])
    },
}
</script>

<style lang="scss">
.flex_c {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
img[src=""],img:not([src]) {
    opacity:0;
}
.choosetickets {
    background: #F5F7FA;
    min-height: 100vh;
    .active_info {
        height: 1.7rem;
        padding: .4rem .3rem;
        background: #fff;
        img {
            display: inline-block;
            width: 2.8rem;
            height: 1.6rem;
            border-radius: .1rem;
            box-shadow: .01rem .01rem 0 #D8D8D8;
            margin-right: .15rem;
        }
        .info {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            font-size: .2rem;
            color: #666;
            flex: 1;
            height: 1.6rem;
            .info_title {
                font-size: .26rem;
                color: #303133;
                line-height: .36rem;
                max-height: .76rem;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                font-weight: 600;
            }
            .info_addr {
                max-height: .56rem;
                line-height: .3rem;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }
    }
    .ticket_list {
        padding: .3rem .3rem 1.5rem .3rem;
        .ticket_item {
            padding: .3rem;
            background: #fff;
            box-shadow: 0 .02rem .06rem 0 rgba(0,0,0,0.1);
            margin-bottom: .2rem;
            border-radius: .1rem;
            justify-content: space-between;
            position: relative;
            align-items: flex-start;
            .item_l {
                .name_ticket {
                    .name {
                        font-size: .28rem;
                        color: #333;
                        font-weight: 600;
                        margin-right: .2rem;
                    }
                    .ticket {
                        font-size: .2rem;
                        color: #FF4747;
                        border: .01rem solid #FF4747;
                        border-radius: .06rem;
                        padding: .06rem .12rem;
                    }
                }
                .price_tips {
                    padding: .2rem 0;
                    .price {
                        font-size: .32rem;
                        color: #0ABF53;
                        margin-right: .3rem;
                    }
                    .tips {
                        font-size: .2rem;
                        color: #999;
                    }
                }
                .ticket_memo {
                    font-size: .2rem;
                    color: #999;
                }
            }
            .item_r {
                img {
                    display: inline-block;
                    width: .95rem;
                    height: .85rem;
                }
            }
            .right_arrow {
                position: absolute;
                right: -.01rem;
                top: -.02rem;
                display: inline-block;
                width: .52rem;
                height: .52rem;
            }
        }
    }
    .fixed_btns {
        position: fixed;
        left: 0;
        bottom: 0;
        height: 1.1rem;
        background: #fff;
        width: 6.9rem;
        padding: 0 .3rem;
        .add {
            flex: 1;
            span {
                display: inline-block;
            }
            .decrease,
            .add_btn {
                width: .38rem;
                height: .38rem;
                border: .01rem solid #0ABF53;
                border-radius: 50%;
                font-size: .44rem;
                color: #0ABF53;
                line-height: .38rem;
                text-align: center;
            }
            .decrease {
                line-height: .35rem;
            }
            .add_btn {
                line-height: .45rem;
            }
            .num {
                width: .5rem;
                text-align: center;
                margin: 0 .24rem;
                font-size: .32rem;
            }
            img {
                display: inline-block;
                width: .38rem;
                height: .38rem;
            }
        }
        .next {
            width:4.4rem;
            height: 0.76rem;
            background: linear-gradient(360deg,rgba(10,191,83,1) 0%,rgba(71,236,201,1) 100%);
            border-radius: .4rem;
            font-size: .32rem;
            color: #fff;
            line-height: .76rem;
            text-align: center;
        }
    }
}
</style>


